import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { TotaraAuthService } from '../services/totara-auth.service';
import { environment } from '@cms_root/environments/environment';

@Injectable()
export class AuthHeadersInterceptor implements HttpInterceptor {
  private _apiKey = environment.totaraApiKey;
  private _apiKeyBase64 = 'Basic ' + btoa(this._apiKey);

  constructor(private totaraAuthService: TotaraAuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let headers = request.headers;

    if (!request.headers.has('X-Client')) {
      headers = headers.append('X-Client', this._apiKeyBase64);
    }

    if (this.totaraAuthService.isAuth && !request.headers.has('Authorization')) {
      const token = this.totaraAuthService.getTokenFromLocalStorage();

      if (token) {
        headers = headers.append('Authorization', `Bearer ${token}`);
      }
    }

    const authRequest = request.clone({ headers });

    return next.handle(authRequest);
  }
}
